import styled from 'styled-components';
import ActionButton from '../UI/ActionButton';

export const CancelarButton = styled(ActionButton)`
  margin: 0;
`;
export const EnviarButton = styled(ActionButton)`
  margin: 0;
`;
